import { Message } from "@mui/icons-material";
import React, { memo } from "react";

import { NodeCard, NodeHandle } from "./nodeKit";

export default memo(({ data, isConnectable, id }) => {
  return (
    <NodeCard color="#2563eb" icon={<Message />} title="Mensagem" id={id}>
      <NodeHandle type="target" isConnectable={isConnectable} />
      {data.label}
      <NodeHandle type="source" id="a" isConnectable={isConnectable} />
    </NodeCard>
  );
});
